<template>
    <div class="emp-card" :key="`emp-${employeeId}`">
        <DxDataGrid :data-source="dsStudii" ref="dataGridRef" :allow-column-reordering="true"
            :allow-column-resizing="true" :column-auto-width="false" :show-borders="true" key-expr="Id">
            <DxSelection mode="single" />
            <DxFilterRow :visible="false" />
            <DxPaging :page-size="10" :page-index="0" />
            <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
            <DxSorting mode="multiple" />
            <DxScrolling mode="standard" :show-scrollbar="'always'" />
            <DxColumnFixing :enabled="true" />
            <DxEditing :allow-updating="true" mode="popup">
                <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="700" :height="450"
                    :show-title="false">
                    <DxToolbarItem :template="customTitleTemplate" />
                    <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="saveButtonOptions" />
                    <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="dangerButtonOptions" />
                </DxPopup>
            </DxEditing>

            <DxColumn data-field="StudyId" width="150" />
            <DxColumn data-field="Descr" width="180" />
            <DxColumn data-field="Duration" width="150" />
            <DxColumn data-field="EndYear" width="100" />
            <DxColumn data-field="IsCourse" width="140" />
            <DxColumn data-field="CourseStartDate" width="150" />
            <DxColumn data-field="CourseEndDate" width="140" />
            <DxColumn data-field="CourseAllowLeaveDate" width="140" />
            <DxColumn data-field="CourseCost" width="100" />
            <DxColumn data-field="Code" width="100" />
            <DxColumn data-field="InstitutionId" width="100" />
            <DxColumn data-field="FacultyId" width="100" />
            <DxColumn data-field="DiplomaId" width="100" />
            <DxColumn data-field="TitleId" width="100" />
            <DxColumn data-field="DomainId" width="100" />
            <DxColumn data-field="SpecialityId" width="100" />
            <DxColumn data-field="Observations" width="100" />
            <DxColumn data-field="CoursePartenerId" width="100" />
            <DxColumn data-field="CourseTopic" width="100" />
            <DxColumn data-field="CourseCertificateNo" width="100" />
            <DxColumn data-field="CourseCor" width="100" />
            <DxColumn data-field="CourseCertificateType" width="100" />
            <DxColumn data-field="CourseCertificateDate" width="100" />
            <DxColumn data-field="CourseCpv" width="100" />


            <DxToolbar>
                <DxItem>
                    <template #default>
                        <DxButton icon="add" type="success" @click="onAddClick" />
                    </template>
                </DxItem>
            </DxToolbar>
        </DxDataGrid>
        <DxPopupAdd :visible="addPopupVisible" :show-title="true" :height="450" :width="700">
            <template #title>
                <div
                    style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
                    Adăugare
                </div>
            </template>
            <DxForm :col-count="2" :data-source="formData" label-alignment="center">
                <DxSimpleItem data-field="StudyId" />
                <DxSimpleItem data-field="Descr" />
                <DxSimpleItem data-field="Duration" />
                <DxSimpleItem data-field="EndYear" />
                <DxSimpleItem data-field="IsCourse" />
                <DxSimpleItem data-field="CourseStartDate" />
                <DxSimpleItem data-field="CourseEndDate" />
                <DxSimpleItem data-field="CourseAllowLeaveDate" />
                <DxSimpleItem data-field="CourseCost" />
                <DxSimpleItem data-field="Code" />
                <DxSimpleItem data-field="InstitutionId" />
                <DxSimpleItem data-field="FacultyId" />
                <DxSimpleItem data-field="DiplomaId" />
                <DxSimpleItem data-field="TitleId" />
                <DxSimpleItem data-field="DomainId" />
                <DxSimpleItem data-field="SpecialityId" />
                <DxSimpleItem data-field="Observations" />
                <DxSimpleItem data-field="CoursePartenerId" />
                <DxSimpleItem data-field="CourseTopic" />
                <DxSimpleItem data-field="CourseCertificateNo" />
                <DxSimpleItem data-field="CourseCor" />
                <DxSimpleItem data-field="CourseCertificateType" />
                <DxSimpleItem data-field="CourseCertificateDate" />
                <DxSimpleItem data-field="CourseCpv" />

            </DxForm>
            <DxToolbarItem widget="dxButton" toolbar="bottom" location="after" :options="addButtonOptions" />
            <DxToolbarItem widget="dxButton" toolbar="bottom" location="after" :options="closeButtonOptions" />
        </DxPopupAdd>
    </div>
</template>
<script lang="ts">
import {
    DxColumn,
    DxDataGrid,
    DxFilterRow,
    DxLoadPanel,
    DxPaging,
    DxSelection,
    DxSorting,
    DxStateStoring,
    DxToolbar,
    DxEditing,
    DxPopup,
    DxItem,
    DxItem as DxFormItem,
    DxForm as DxFormGrid,
    DxValidationRule,
    DxRequiredRule,
    DxSearchPanel,
    DxScrolling,
    DxColumnFixing
} from 'devextreme-vue/data-grid';
import { DxCheckBox } from 'devextreme-vue/check-box';
import DxTextArea from 'devextreme-vue/text-area';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import { defineComponent, ref } from 'vue';
import DataSource from 'devextreme/data/data_source';
import { DxButton } from 'devextreme-vue/button';
import notify from 'devextreme/ui/notify';
import { DxForm, DxSimpleItem } from "devextreme-vue/form"
import DxPopupAdd from 'devextreme-vue/popup'
import { DxToolbarItem } from 'devextreme-vue/popup';
import PER_Meserii from '@/services/PER/PER_Meserii';


export default defineComponent({
    components: {
        DxColumn,
        DxDataGrid,
        DxFilterRow,
        DxLoadPanel,
        DxPaging,
        DxSelection,
        DxSorting,
        DxStateStoring,
        DxToolbar,
        DxEditing,
        DxValidationRule,
        DxRequiredRule,
        DxItem,
        DxButton,
        DxSearchPanel,
        DxForm,
        DxPopupAdd,
        DxSimpleItem,
        DxTextArea,
        DxCheckBox,
        DxToolbarItem,
        DxPopup,
        DxFormGrid,
        DxFormItem,
        DxScrolling,
        DxColumnFixing
    },
    props: {
        employeeId: { type: String, required: true },
        employeeRow: { type: Object, default: null }
    },
    watch: {
        employeeId: {
            immediate: true,
            handler(id) {
                if (!id || !this.$refs.dataGridRef?.instance) return;
                const ds = this.$refs.dataGridRef.instance.getDataSource();
                ds.filter(["EmpId", "=", id]);
                ds.load();
            }
        }
    },
    data() {
        return {
            dsStudii: {} as DataSource,
            dataGridRef: ref<DxDataGrid | null>(null),
            addPopupVisible: false,
            editPopupVisible: false,
            formData: {
                Id: null,
                EmpId: null,
                StudyId: null,
                Descr: '',
                Duration: null,
                EndYear: null,
                IsCourse: false,
                CourseStartDate: '',
                CourseEndDate: '',
                CourseAllowLeaveDate: '',
                CourseCost: null,
                Code: '',
                InstitutionId: null,
                FacultyId: null,
                DiplomaId: null,
                TitleId: null,
                DomainId: null,
                SpecialityId: null,
                Observations: '',
                UserCreare: '',
                DataCreare: '',
                UserModificare: '',
                DataModificare: '',
                CoursePartenerId: null,
                CourseTopic: '',
                CourseCertificateNo: '',
                CourseCor: '',
                CourseCertificateType: null,
                CourseCertificateDate: '',
                CourseCpv: ''
            },
            addButtonOptions: {
                type: "success",
                text: "Salvează",
                stylingMode: "contained",
                onClick: () => {
                    this.onSaveAdd()
                }
            },
            saveButtonOptions: {
                type: "success",
                text: "Salvează",
                stylingMode: "contained",
                onClick: () => {
                    this.onSaveEdit()
                }
            },
            closeButtonOptions: {
                type: "danger",
                text: "Închide",
                stylingMode: "contained",
                onClick: () => {
                    this.onCloseAdd()
                }
            },
            dangerButtonOptions: {
                type: "danger",
                text: "Închide",
                stylingMode: "contained",
                onClick: () => {
                    this.closeEditPopup()
                }
            },
            customTitleTemplate() {
                return `
        <div style="background-color: #ff2c21; font-size: 16px; float: right; height:47px; width:880px; color: white; 
        font-weight: bold;  padding: 12px; padding-right: 450px;  position: relative;  left: 30px;">
          Editare
        </div>
      `;
            },
        }
    },

    mounted() {
        this.dsStudii = new DataSource({
            store: new ODataStore({
                version: 4,
                url: AppSetting.API_Url_ResurseUmaneOdata + "PER_EmpStudies",
                key: "Id",
                fieldTypes: { Id: "Guid", EmpId: "Guid" },
                beforeSend: e => {
                    e.headers = { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") };
                }
            }),
            // setez filtrul inițial aici
            filter: ["EmpId", "=", this.employeeId]
        });
    },
    methods: {
        closeEditPopup() {
            this.dataGridRef?.instance?.cancelEditData();
        },
        onAddClick() {
            this.addPopupVisible = true
        },
        async onSaveEdit() {
            const gridInstance = this.dataGridRef?.instance;
            if (!gridInstance) {
                notify('Eroare: Grila nu este încărcată.', 'error', 2000);
                return;
            }
            try {
                gridInstance.saveEditData()
                notify('Datele au fost salvate cu succes!', 'success', 2000);
            } catch (error: any) {
                console.error("Eroare la salvarea editării:", error);
            }
        },
        onSaveAdd() {
            if (!this.newMeserie.name || this.newMeserie.name.trim() === '') {
                notify('Completați câmpul obligatoriu "Nume"!', 'error', 2000)
                return
            }
            if (!this.newMeserie.code || this.newMeserie.code.trim() === '') {
                notify('Completați câmpul obligatoriu "Cod"!', 'error', 2000)
                return
            }
            PER_Meserii.save(this.newMeserie).then((meserie) => {
                this.addPopupVisible = false
                notify('Datele au fost salvate cu succes!', 'success', 2000)
                this.newMeserie = {
                    name: '',
                    code: '',
                    Active: false,
                }
                this.onRefreshClick()
            }).catch((error) => {
                console.error(error);
                notify('Datele există deja!', 'error', 2000);
            })
        },
        onCloseAdd() {
            this.addPopupVisible = false

        },


    },
})
</script>
<style>
.circle-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.circle {
    width: 12px;
    height: 12px;
}

.circle-true {
    background-color: #4caf50;
    color: white;
}

.circle-false {
    background-color: #e71010;
}
</style>